export default __webpack_public_path__ + "static/media/question.7c4d4e0f.svg";